import Vue from 'vue';
import { MUTATION_REGISTER_SNAPSHOT_LISTENER } from './constants';
import {
  firestoreDocumentsByQuery,
  onSnapshot,
} from '../firebase/firestore';

const MODULE_PREFIX = 'globalConfig';
const GETTER_CONFIGURATION = 'config';
const MUTATION_GLOBAL_CONFIG = 'GLOBAL_CONFIG';
const ACTION_FETCH_GLOBAL_CONFIG = 'fetchGlobalConfig';

const onGlobalConfigSnapshot = (commit, snapshot) => {
  if (snapshot.docs.length !== 1) {
    throw new Error('Unable to get global config from configurations collection');
  }

  commit(MUTATION_GLOBAL_CONFIG, snapshot.docs[0].data());
};

const initialState = {
  configOptions: [],
};

const mutations = {
  [MUTATION_GLOBAL_CONFIG]: (state, configData) => {
    const { configName, version, ...configOptions } = configData;
    Vue.set(state, 'configOptions', configOptions);
  },
};


const actions = {
  [ACTION_FETCH_GLOBAL_CONFIG]: async ({ commit }) => {
    const query = firestoreDocumentsByQuery(
      'configurations',
      [{ key: 'configName', operator: '==', value: 'frontend' }],
      { field: 'version', order: 'desc' },
      1,
    );
    const unsubscribe = onSnapshot(query, onGlobalConfigSnapshot.bind(this, commit));
    commit(
      MUTATION_REGISTER_SNAPSHOT_LISTENER, { snapshotListener: unsubscribe, id: 'configurations' }, { root: true },
    );
  },
};

const getters = {
  [GETTER_CONFIGURATION]: state => state.configOptions,
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export const types = {
  getters: {
    config: `${MODULE_PREFIX}/${GETTER_CONFIGURATION}`,
  },
  actions: {
    fetchGlobalConfig: `${MODULE_PREFIX}/${ACTION_FETCH_GLOBAL_CONFIG}`,
  },
};

export const configValues = {
  collabServerUrl: 'collabServerUrl',
};
